module.exports = __webpack_public_path__ + "static/media/erdbdelete.632010ec.svg";